import axios from "axios";
import config from "../config/config";

// ---- Axios instance ----
const API = axios.create({
  baseURL: config.endpointUrl,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "MLW-API-KEY": config.apiSecretId
  },
    withCredentials: true
});



// API.interceptors.request.use((config) => {

//   const token = localStorage.getItem("token");

//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }

//   return config;
// });



// API.interceptors.response.use(
//   (response) => response,
//   (error) => {

//     if (error.response?.status === 401) {
//       localStorage.removeItem("token");
//       window.location.href = "/login";
//     }

//     return Promise.reject(error);
//   }
// );

export default API;